import { takeEvery, put, call } from "redux-saga/effects";
import {
  FETCH_DEPARTMENTS,
  CREATE_DEPARTMENT_REQUEST,
  DELETE_DEPARTMENT,
} from "./actionTypes";
import {
  fetchDepartments,
  fetchDepartmentsSuccess,
  fetchDepartmentsFailure,
  createDepartmentSuccess,
  createDepartmentFailure,
  deleteDepartmentSuccess,
  deleteDepartmentFailure,
} from "./actions";
import { post } from "../../../helpers/api_helper";
import Swal from "sweetalert2";

// Fetch Departments
function* fetchDepartmentsSaga({ payload: { companyId } }) {
  try {
    const formData = new FormData();
    formData.append("unit_id", companyId);

    const response = yield call(post, process.env.REACT_APP_GET_DEPARTMENTS, formData);

    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to retrieve departments!");
    }

    yield put(fetchDepartmentsSuccess(response));
  } catch (error) {
    console.error("Fetch Departments Saga Error:", error);
    yield put(fetchDepartmentsFailure(error.message));
  }
}

// Create Department Saga
function* createDepartmentSaga({ payload }) {
  try {
    const { formData, isEdit } = payload;
    const response = yield call(post, process.env.REACT_APP_CREATE_DEPARTMENT, formData);

    if (response?.status === "success") {
      Swal.fire({
        icon: "success",
        title: "Success",
        text: response.message || "Department saved successfully!",
      });
      yield put(createDepartmentSuccess(response));
      const unitId = formData.get("unit_id"); 
      if (unitId) {
        yield put(fetchDepartments(unitId));
      } else {
        console.log("unit_id is missing in formData, fetch not triggered");
      }
    } else {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: response.message || "Something went wrong!",
      });
      yield put(createDepartmentFailure("Unexpected response format"));
    }
  } catch (error) {
    console.error("Create Department Saga Error:", error);
    Swal.fire({
      icon: "error",
      title: "API Error",
      text: error.message || "An error occurred while saving the department",
    });
    yield put(createDepartmentFailure(error.message));
  }
}

// Delete Department Saga
function* deleteDepartmentSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_DELETE_DEPARTMENT, action.payload);

    if (response?.status === "success") {
      Swal.fire({
        icon: "success",
        title: "Deleted!",
        text: response.message || "Department deleted successfully!",
      });
      yield put(deleteDepartmentSuccess(response));
    } else {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: response.message || "Failed to delete department!",
      });
      yield put(deleteDepartmentFailure("Unexpected response format"));
    }
  } catch (error) {
    console.error("Delete Department Saga Error:", error);
    Swal.fire({
      icon: "error",
      title: "API Error",
      text: error.message || "An error occurred while deleting the department",
    });
    yield put(deleteDepartmentFailure(error.message));
  }
}

// Watcher Saga
function* departmentSaga() {
  yield takeEvery(FETCH_DEPARTMENTS, fetchDepartmentsSaga);
  yield takeEvery(CREATE_DEPARTMENT_REQUEST, createDepartmentSaga);
  yield takeEvery(DELETE_DEPARTMENT, deleteDepartmentSaga);
}

export default departmentSaga;
